module.exports = __webpack_public_path__ + "img/07_logo_3_light_white.5a5ba3c6.svg";